import React, { useCallback, useEffect, useState } from 'react';

import { ResourcePicker } from '@shopify/app-bridge-react';
import axios from 'axios';

import { Layout, Card, Spinner, Button, Toast, ResourceList, Thumbnail, ResourceItem, TextStyle } from '@shopify/polaris';



const ProductSettings = () => {

    const [loaded, setLoaded] = useState(true);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [toastActive, setToastActive] = useState(false)
    const [errToastActive, setErrToastActive] = useState(false)
    const [openResoucePicker, setOpenResourcePicker] = useState(false)

    const handleSelection = useCallback((resources) => {
        setLoaded(true)

        console.log('resources', resources)

        const products = resources.selection.map(x => {
            return {
                title: x.title,
                id: x.id,
                variantSKUs: x.variants.flatMap(y => y.sku),
                image: x.images[0].originalSrc
            }
        })

        console.log('products', products)

        const noSku = products.flatMap(x => x.variantSKUs);

        if (noSku.indexOf(null) !== -1) {
            setErrToastActive(true)
            return
        }

        axios.post('/settings/save-skus', { products: products })
        .then(data => {
            setToastActive(true)
            updateProduct()
        })
    }, [])

    useEffect(() => {
        setLoaded(false)
        updateProduct()
    }, [])

    const updateProduct = () => {
        axios.get('/settings/get-skus')
        .then(resp => {
            console.log(resp.data)
            setSelectedProducts(selectedProducts => [...resp.data])
            setLoaded(true)
        })
    }

    const deleteProducts = (_id) => {
        console.log(_id)
        setLoaded(false)
        axios.post('/settings/delete-skus', { id: _id })
        .then(resp => {
            console.log(resp.data)
            updateProduct()
        })
    }

    const toggleActive = useCallback(() => setToastActive((toastActive) => !toastActive), []);
    const toggleErrActive = useCallback(() => setErrToastActive((errToastActive) => !errToastActive), []);

    const toastMarkup = toastActive ? (
        <Toast content="Saved!" onDismiss={toggleActive} />
      ) : null;

      const errToastMarkup = errToastActive ? (
        <Toast content="SKU Missing" error onDismiss={toggleErrActive} />
      ) : null;

      const resoursePickerOpener = useCallback(() => {
        setOpenResourcePicker(openResoucePicker => !openResoucePicker)
      }, [setOpenResourcePicker])

      const resoursePickerCloser= useCallback(() => {
        setOpenResourcePicker(false)
      }, [setOpenResourcePicker])

    return (
        <>
        <ResourcePicker
          resourceType="Product"
          showVariants={false}
          open={openResoucePicker}
          onSelection={handleSelection}
          onCancel={resoursePickerCloser}
        />
        <Layout>
            <Layout.AnnotatedSection
                title="Select Product"
                description="Customizable Products"
            >
                <Card sectioned>
                    {!loaded && (<Spinner accessibilityLabel="Spinner" size="large" color="teal" />)}

                    <Button primary onClick={resoursePickerOpener}>Select Products</Button>

                    <ResourceList
                        resourceName={{singular: 'Product', plural: 'Products'}}
                        items={selectedProducts}
                        renderItem={(selectedProduct) => {
                            const { title, _id, image } = selectedProduct
                            const media = <Thumbnail source={image} alt={title} />
                            const shortcutActions = [
                                {
                                  content: 'Delete',
                                  accessibilityLabel: `Delete ${title}`,
                                  onAction: () => { deleteProducts(_id) }
                                }
                            ]

                            return (
                                <ResourceItem
                                    id={_id}
                                    media={media}
                                    accessibilityLabel={`View details`}
                                    shortcutActions={shortcutActions}
                                >
                                    <h3>
                                    <TextStyle variation="strong">{title}</TextStyle>
                                    </h3>
                                </ResourceItem>
                            );
                        }}
                    />

                </Card>
            </Layout.AnnotatedSection>
        </Layout>
        {toastMarkup}
        {errToastMarkup}
        </>
    )
}

export default ProductSettings;